import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.toggleVisible
        ? _vm._t(
            "show",
            function () {
              return [
                _c(
                  VTooltip,
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBtn,
                                _vm._g(
                                  {
                                    attrs: {
                                      absolute: "",
                                      color: "secondary",
                                      dark: "",
                                      fab: "",
                                      right: "",
                                      top: "",
                                    },
                                    on: { click: _vm.show },
                                  },
                                  on
                                ),
                                [_c(VIcon, [_vm._v("help")])],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2144804386
                    ),
                  },
                  [_c("span", [_vm._v("Em caso de dúvidas, clique aqui")])]
                ),
              ]
            },
            { show: _vm.show }
          )
        : _vm._e(),
      _c(
        VDialog,
        {
          attrs: { "max-width": "85%", persistent: "" },
          on: { "click:outside": _vm.close },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [_vm.showDialog ? _c(_vm.tutorial, { tag: "component" }) : _vm._e()],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }